<template>
  <div>
    <div
      class="elemento-nao-quebrar"
      v-for="(boleto, index) in boletos"
      :key="index"
    >
      <boleto :dadosBoleto="boleto" />
      <div class="linha-tracejada"></div>
    </div>
  </div>
</template>
<script>
import boleto from './../Includes/boleto.vue';

import services from '../../services';

export default {
  name: 'todos-boletos',
  components: {
    boleto,
  },
  data() {
    return {
      controller: 'Boletos',
      action: `buscar-boletos-por-apolice/${this.$route.params.idApolice}`,
      boletos: [],
    };
  },
  created() {
    this.getBoletos();
  },
  methods: {
    async getBoletos() {
      const { data } = await services.getAll(
        this.controller,
        null,
        this.action,
      );

      for (const boleto of data) {
        this.montaBoletoBemProtege(boleto);
      }
    },
    montaBoletoBemProtege(dados) {
      const dadosEmpresa = JSON.parse(dados.dadosEmpresa)[0];
      const dadosAssociado = JSON.parse(dados.dadosAssociado)[0];
      const dadosCobranca = JSON.parse(dados.dadosCobranca)[0];

      const boletoBemProtege = {
        dadosEmpresa: {
          nome: dadosEmpresa.razaoSocial,
          cpfcnpj: dadosEmpresa.cnpj,
          endereco: dadosEmpresa.endereco,
          numero: dadosEmpresa.numero,
          complemento: dadosEmpresa.complemento,
          bairro: dadosEmpresa.bairro,
          cidade: dadosEmpresa.cidade,
          estado: dadosEmpresa.estado,
          cep: dadosEmpresa.cep,
          logo: dadosEmpresa.logo,
        },
        dadosPagador: {
          nome: dadosAssociado.nome,
          cpfcnpj: dadosAssociado.cpfcnpj,
          endereco: dadosAssociado.endereco,
          numero: dadosAssociado.numero,
          complemento: dadosAssociado.complemento,
          bairro: dadosAssociado.bairro,
          cidade: dadosAssociado.cidade,
          estado: dadosAssociado.estado,
          cep: dadosAssociado.cep,
        },
        dadosCobranca: {
          id: dados.id,
          dataVencimento: dados.data_vencimento,
          dataEmissao: dados.data_emissao,
          valor: dados.valor_boleto,
          nossoNumero: dados.id_integracao || dados.nosso_numero,
          instrucao: dadosCobranca.instrucaoCaixa,
          linhaDigitavel: dados.linha_digitavel,
          barCode: dados.codigoBarras,
          banco: {
            nomeBanco: dadosCobranca.shortName,
            logoBanco: dadosCobranca.urlLogo,
            codigoBanco: dadosCobranca.COMPE,
            digitoBanco: '7',
            agencia: dadosCobranca.agencia,
            conta: dadosCobranca.conta,
            carteira: dadosCobranca.numeroCarteira,
          },
          placa: dados.placa,
          chassi: dados.chassi,
          multa: dadosCobranca.percentualMulta,
          juros: dadosCobranca.percentualJurosDiario,
          pix: dados.pix_emv,
          originalLimitDatePayment: dados.originalLimitDatePayment,
          referente: dados.referente,
          instrucaoInicial: dadosCobranca.instrucaoInicial,
        },
      };
      this.boletos.push({ ...dados, dadosToBoleto: boletoBemProtege });
    },
    imprimir(time = 1000) {
      setTimeout(() => {
        window.print();
      }, time);
    },
  },
};
</script>
<style scoped>
.linha-tracejada {
  border-bottom: 5px dashed #ccc; /* Cor e estilo da linha */
  margin: 20px 0; /* Espaçamento acima e abaixo da linha */
}
.elemento-nao-quebrar {
  page-break-inside: avoid; /* Para navegadores mais antigos */
  break-inside: avoid; /* Para navegadores modernos */
}
</style>
